var map = {
	"./az.svg": "4a90",
	"./bd.svg": "5edd",
	"./bn.svg": "0af4",
	"./cn.svg": "4ff8",
	"./de.svg": "0396",
	"./en.svg": "364d",
	"./es.svg": "694c",
	"./fr.svg": "2a9a",
	"./id.svg": "8a8a",
	"./in.svg": "b4ad",
	"./it.svg": "7bc1",
	"./jp.svg": "ff7b",
	"./kg.svg": "be38",
	"./kz.svg": "294a",
	"./pl.svg": "ec7d",
	"./pt.svg": "24fb",
	"./ro.svg": "0c7f",
	"./ru.svg": "1d6d",
	"./tg.svg": "9f40",
	"./tr.svg": "c9e8",
	"./tz.svg": "65c9",
	"./ua.svg": "b260",
	"./uz.svg": "2565"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b35b";